import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Icon, StyledIconWrapper } from "@/components/Icon";
import { Badge } from "@/components/Badge";
import { Image } from "@/components/Image";

import { IMediaElement } from "../types";

export const ConversionImage: React.FC<IMediaElement> = ({
  image,
  title,
  iconType,
}) => {
  const { css } = useFela();
  const { colors } = useTheme();

  return (
    <div
      className={css({
        position: "relative",
      })}
    >
      <Image
        alt={title}
        src={image}
        customStyle={{
          width: "100%",
          maxWidth: 540,
          maxHeight: 330,
          borderRadius: 8,
          boxShadow: `20px 20px 80px ${colors.CETACEAN_BLUE}`,
        }}
      />

      <div
        className={css({
          top: 0,
          left: "50%",
          position: "absolute",
          transform: "translate(-50%, -50%)",
        })}
      >
        <Badge
          size={64}
          customStyle={{
            backgroundColor: colors.WHITE,
            boxShadow: `4px 8px 8px 0 ${colors.CETACEAN_BLUE}`,
          }}
        >
          <StyledIconWrapper height={29}>
            <Icon iconType={iconType} />
          </StyledIconWrapper>
        </Badge>
      </div>
    </div>
  );
};
